/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSupportingExaminationDto } from './GetSupportingExaminationDto';
import {
    GetSupportingExaminationDtoFromJSON,
    GetSupportingExaminationDtoFromJSONTyped,
    GetSupportingExaminationDtoToJSON,
} from './GetSupportingExaminationDto';
import type { GetAttachmentDto } from './GetAttachmentDto';
import {
    GetAttachmentDtoFromJSON,
    GetAttachmentDtoFromJSONTyped,
    GetAttachmentDtoToJSON,
} from './GetAttachmentDto';

/**
 * 
 * @export
 * @interface GetSynevoOrderDto
 */
export interface GetSynevoOrderDto {
    /**
     * 
     * @type {string}
     * @memberof GetSynevoOrderDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSynevoOrderDto
     */
    systemNumber: number;
    /**
     * 
     * @type {GetSupportingExaminationDto}
     * @memberof GetSynevoOrderDto
     */
    supportingExamination: GetSupportingExaminationDto;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoOrderDto
     */
    synevoResultId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSynevoOrderDto
     */
    resultDate?: Date | null;
    /**
     * 
     * @type {GetAttachmentDto}
     * @memberof GetSynevoOrderDto
     */
    attachment?: GetAttachmentDto | null;
}

/**
 * Check if a given object implements the GetSynevoOrderDto interface.
 */
export function instanceOfGetSynevoOrderDto(value: object): value is GetSynevoOrderDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('supportingExamination' in value) || value['supportingExamination'] === undefined) return false;
    return true;
}

export function GetSynevoOrderDtoFromJSON(json: any): GetSynevoOrderDto {
    return GetSynevoOrderDtoFromJSONTyped(json, false);
}

export function GetSynevoOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSynevoOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'supportingExamination': GetSupportingExaminationDtoFromJSON(json['supportingExamination']),
        'synevoResultId': json['synevoResultId'] == null ? undefined : json['synevoResultId'],
        'resultDate': json['resultDate'] == null ? undefined : (new Date(json['resultDate'])),
        'attachment': json['attachment'] == null ? undefined : GetAttachmentDtoFromJSON(json['attachment']),
    };
}

export function GetSynevoOrderDtoToJSON(value?: GetSynevoOrderDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'systemNumber': value['systemNumber'],
        'supportingExamination': GetSupportingExaminationDtoToJSON(value['supportingExamination']),
        'synevoResultId': value['synevoResultId'],
        'resultDate': value['resultDate'] == null ? undefined : ((value['resultDate'] as any).toISOString()),
        'attachment': GetAttachmentDtoToJSON(value['attachment']),
    };
}

